import { isArrayWithLength } from '@natu/utils/isArrayWithLength';

import type { BlokItem } from '../../../../utils';

type ItemProp = BlokItem<'serviceCardItem'> & {
  title?: string;
  subtitle?: string;
  body?: string;
  cta?: BlokItem[];
};

type FaqSchemaFromServicesListProps = {
  items?: ItemProp[];
};

export const FaqSchemaFromServicesList = ({ items }: FaqSchemaFromServicesListProps) => {
  const validItems = items?.filter(item => item?.title).filter(Boolean) || [];

  if (!isArrayWithLength(validItems)) return null;

  const faqItems = validItems.map(item => {
    const answerParts: string[] = [];

    if (item.subtitle) {
      answerParts.push(item.subtitle);
    }

    if (item.body) {
      answerParts.push(item.body);
    }

    if (item.cta && isArrayWithLength(item.cta)) {
      const ctaLabels = item.cta
        .map(ctaItem => ctaItem.content as string | undefined)
        .filter((label): label is string => Boolean(label));

      if (isArrayWithLength(ctaLabels)) {
        answerParts.push(...ctaLabels);
      }
    }

    const answerText = answerParts.join(' ');

    return {
      '@type': 'Question',
      name: item.title,
      acceptedAnswer: {
        '@type': 'Answer',
        text: answerText,
      },
    };
  });

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqItems,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
    />
  );
};
